import { ScreenContext } from '@/contexts/ScreenContext';
import { useRwdUI } from '@/hooks/useRwdUI';
import i18n from '@/modules/locales/i18n';
import { BetRecord } from '@/modules/report/slice/betSummary';
// import { getVHByRem } from '@/utils/commonFunc';
import { AmountText } from '@/utils/formatter';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useWindowSize } from '@react-hook/window-size';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import AutoSizer from 'react-virtualized-auto-sizer';
// import { FixedSizeList } from 'react-window';
// import { DetailListDivider, ReportDivider } from '../../../ReportDivider';
import { GetBetTypeToString } from '../../util';
import '../index.scss';

// const BET_ITEM_NUM = 4;

type UnsuccessBetContentProps = {
    betRecords: Array<BetRecord>;
    gameType: number;
    result: string; //For BJ use
};
export const UnsuccessBetContent = (props: UnsuccessBetContentProps) => {
    const { t } = useTranslation();

    const { pxToRwdNumber } = useRwdUI();
    const [width, height] = useWindowSize({ wait: 100 });
    const { isLandscape, scaleFactor } = useContext(ScreenContext);
    const { betRecords, gameType, result } = props;

    const [itemHeight, setItemHeight] = useState(1);

    useEffect(() => {
        setItemHeight(pxToRwdNumber(isLandscape ? 120 : 60));
    }, [width, height, isLandscape, betRecords, scaleFactor]);

    const [betContentList, setBetContentList] = useState(<></>);
    // const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (betRecords && betRecords.length > 0) {
            setBetContentList(
                <>
                    {betRecords.map((rec, index) => (
                        <div key={`bet-record-${index}-${rec.GameID}`}>
                            <BetContentItem
                                record={rec}
                                gameType={gameType}
                                result={result}
                            />
                            {index !== betRecords.length - 1 && (
                                <div className="bet-content-divider" />
                            )}
                        </div>
                    ))}
                </>
            );
            // setBetContentList(
            //     <AutoSizer>
            //         {({ width, height }) => (
            //             <FixedSizeList
            //                 className="hide-scrollbar"
            //                 height={height}
            //                 width={width}
            //                 itemCount={betRecords.length}
            //                 itemSize={itemHeight}
            //                 itemData={betRecords}
            //                 itemKey={(index, data) =>
            //                     `bet-record-${index}-${data[index].GameID}`
            //                 }
            //             >
            //                 {({ index, style, data }) => (
            //                     <div
            //                         style={{
            //                             ...style,
            //                             height: itemHeight,
            //                         }}
            //                     >
            //                         <BetContentItem
            //                             record={data[index]}
            //                             gameType={gameType}
            //                         />
            //                     </div>
            //                 )}
            //             </FixedSizeList>
            //         )}
            //     </AutoSizer>
            // );
            // setContentHeight(
            //     itemHeight * Math.min(betRecords.length, BET_ITEM_NUM)
            // );
        }
        // else {
        //     setBetContentList(
        //         <Grid
        //             item
        //             container
        //             justifyContent="center"
        //             sx={{
        //                 // margin: '0 0 1rem 0',
        //                 fontSize: isLandscape ? getVHByRem(1) : '1rem',
        //             }}
        //         >
        //             {t('betlog.noRecord')}
        //         </Grid>
        //     );
        //     setContentHeight(1);
        // }
    }, [betRecords, itemHeight]);

    return (
        <Box className="bet-content-container">
            <Grid container className="bet-content-header">
                <Grid item className="bet-content-header-item bet-type">
                    {t('betlog.bet_type')}
                </Grid>
                <Grid item className="bet-content-header-item bet-amount">
                    {t('betlog.bet_amount')}
                </Grid>
                <Grid item className="bet-content-header-item remark">
                    {t('betlog.remark')}
                </Grid>
            </Grid>
            <div className="bet-content-list hide-scrollbar">
                {betContentList}
            </div>
            {/* <DetailListDivider /> */}
            {/* <Box height={contentHeight}>{betContentList}</Box> */}
        </Box>
    );
};

type BetContentItemProps = {
    record: BetRecord;
    gameType: number;
    result: string; //For BJ Use
};

const BetContentItem = (props: BetContentItemProps) => {
    const { record, gameType, result } = props;

    return (
        <div className="bet-content-item-container-wrapper">
            <Grid container className="bet-content-item-container">
                <Grid item className="bet-content-item bet-type">
                    <span>
                        {GetBetTypeToString(gameType, record.BetType, result)}
                    </span>
                </Grid>
                <Grid item className="bet-content-item bet-amount">
                    <AmountText
                        amount={record.BetAmount / 100}
                        textAlign={'end'}
                        with_color={false}
                        with_sign={false}
                    />
                </Grid>
                <Grid item className="bet-content-item remark">
                    <BetRemark reason={record.Reason} />
                </Grid>
            </Grid>
            {/* <ReportDivider isCell={true} /> */}
        </div>
    );
};

const BetRemark = ({ reason }: { reason: string | undefined }) => {
    const { t } = useTranslation();
    let errorMsg = `abc_failure_betlog.error_code.${reason}`;
    if (!isMessageExist(errorMsg)) {
        errorMsg = 'abc_failure_betlog.error_common';
        return <>{t(errorMsg).replace('{{errorcode}}', reason ?? '')}</>;
    } else {
        return <>{t(errorMsg)}</>;
    }
};

const isMessageExist = (key: string) => {
    return i18n.exists(key);
};
